export const castItems = [
  {
    id: 'cast-1',
    type: 'cast',
    title: '林知远',
    subtitle: '饰 陈默｜纪录片导演，全剧的情绪锚点',
    excerpt:
      '林知远以克制的表演方式塑造了陈默这个"什么都懂、什么都不说"的角色。他习惯用停顿代替台词，被观众称为"沉默派"演员。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20quiet%20Chinese%20man%20in%20his%20late%20thirties%20wearing%20a%20dark%20wool%20coat%2C%20short%20black%20hair%2C%20calm%20restrained%20expression%2C%20warm%20amber%20side%20lighting%20against%20a%20deep%20charcoal%20backdrop%2C%20shallow%20depth%20of%20field%2C%20subtle%20film%20grain%2C%20editorial%20movie%20still%20portrait%2C%20muted%20warm%20color%20grading&width=800&height=1000&seq=cast-portrait-01&orientation=portrait',
    date: '2025-01-08',
    dateLabel: '主演阵容',
    weight: 99,
    tags: ['主演', '陈默', '沉默派', '克制'],
    meta: [
      { label: '饰演角色', value: '陈默（纪录片导演）' },
      { label: '出场集数', value: '全 12 集' },
      { label: '代表作品', value: '《长夜将尽》《归途列车》《我的朋友他的妻子》' },
      { label: '表演风格', value: '克制、留白、以停顿叙事' },
    ],
    quote: '陈默不是在忍，他只是把话留给了镜头。',
    body: [
      '林知远在接演陈默之前，有将近两年没有接戏。他说自己需要一段"什么都不演"的时间，去菜市场、去长途车站，看普通人怎么沉默。',
      '为了这个角色，他做了三件事：把台词量主动砍掉三分之一；每天提前两小时到片场，坐在场景里不说话；以及写了一本只给自己看的人物日记，从陈默十九岁写到三十六岁。',
      '剧中最被讨论的"深夜来电"一场戏，他几乎没有做表情。导演后来回忆，那一条拍完现场没有人说话，收音师忘了喊停。',
      '林知远自己这样解释这个角色：他不是深情，他是胆小。他害怕一开口，就再也回不到朋友的位置。这句话后来被很多观众截图转发。',
    ],
  },
  {
    id: 'cast-2',
    type: 'cast',
    title: '苏婉宁',
    subtitle: '饰 江暖｜在报恩与自洽之间走了七年',
    excerpt:
      '苏婉宁把江暖演成了一个"不无辜但也不该被责怪"的人。她拒绝把角色处理成苦情，而是让人看到她每一步选择里的清醒。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20an%20elegant%20Chinese%20woman%20in%20her%20mid%20thirties%20with%20shoulder%20length%20wavy%20dark%20hair%2C%20cream%20knit%20sweater%2C%20composed%20melancholic%20gaze%2C%20warm%20honey%20rim%20lighting%20on%20a%20deep%20brown%20studio%20background%2C%20soft%20shadows%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20premium%20editorial%20portrait&width=800&height=1000&seq=cast-portrait-02&orientation=portrait',
    date: '2025-01-08',
    dateLabel: '主演阵容',
    weight: 97,
    tags: ['主演', '江暖', '女性视角', '抉择'],
    meta: [
      { label: '饰演角色', value: '江暖（旧城酒吧主理人）' },
      { label: '出场集数', value: '全 12 集' },
      { label: '代表作品', value: '《春分之后》《南方来信》《我的朋友他的妻子》' },
      { label: '表演风格', value: '细腻、层次分明、情绪内收' },
    ],
    quote: '我不想演一个被同情的人，我想演一个做选择的人。',
    body: [
      '苏婉宁拿到剧本后，先问了导演一个问题：江暖有没有哪怕一刻，是自私的？得到肯定答复之后，她才答应出演。',
      '她坚持在第八集的海边戏里删掉一段哭戏，改成长时间的沉默。"她已经哭过七年了，那天她只是累。"这场戏最终成为全剧评价最高的一幕。',
      '在片场，她会给江暖的每件衣服写一个年份标签——哪一年买的、谁付的钱、还留着是因为舍不得还是因为习惯。这些细节大多不会出现在画面里，但她认为角色需要。',
      '她形容江暖是一个"把体面当成盔甲的人"：所有人看到的是得体，只有观众知道那身盔甲有多重。',
    ],
  },
  {
    id: 'cast-3',
    type: 'cast',
    title: '顾清和',
    subtitle: '饰 陆嘉行｜不是反派，只是先一步承担的人',
    excerpt:
      '顾清和主动要求删掉角色的"暴怒戏"，他认为陆嘉行的痛不该靠吼出来，而应该藏在礼貌和克制之下。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20poised%20Chinese%20man%20in%20his%20early%20forties%20wearing%20a%20tailored%20charcoal%20suit%20with%20no%20tie%2C%20neatly%20combed%20hair%2C%20faintly%20weary%20but%20composed%20expression%2C%20warm%20amber%20key%20light%20from%20the%20side%2C%20deep%20dark%20background%2C%20subtle%20film%20grain%2C%20refined%20cinematic%20portrait%20photography&width=800&height=1000&seq=cast-portrait-03&orientation=portrait',
    date: '2025-01-08',
    dateLabel: '主演阵容',
    weight: 95,
    tags: ['主演', '陆嘉行', '复杂角色', '克制'],
    meta: [
      { label: '饰演角色', value: '陆嘉行（建筑事务所合伙人）' },
      { label: '出场集数', value: '第 2—12 集' },
      { label: '代表作品', value: '《白露为霜》《城市之光》《我的朋友他的妻子》' },
      { label: '表演风格', value: '外放收束、礼帽式表演' },
    ],
    quote: '他不是来抢的，他是那个先低头收拾残局的人。',
    body: [
      '顾清和第一次读完剧本，给导演发了条消息：这个角色不能坏，一坏整部戏就塌了。',
      '他给陆嘉行设计了一个小动作——每次情绪要失控时，会先整理袖口。全剧出现了十一次，只有最后一次没有整理，那是在楼梯间。',
      '第七集的对手戏，他和林知远在拍摄前对了整整一晚的台词，最后决定"谁都不看谁的眼睛"。观众看到的是两个人都在看楼梯的台阶。',
      '顾清和说，陆嘉行最让人难受的地方在于：他做的每一件事都合乎道理，可道理加起来，仍然没能留住一个人。',
    ],
  },
  {
    id: 'cast-4',
    type: 'cast',
    title: '沈言',
    subtitle: '饰 温以宁｜剧组的"局外人"，观众的替身',
    excerpt:
      '沈言饰演的纪录片制片人温以宁，是全剧唯一敢当面拆穿三个人关系的人。她的戏份不多，却常常推动转折。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20sharp%20Chinese%20woman%20in%20her%20early%20thirties%20with%20a%20short%20blunt%20bob%20haircut%20and%20thin%20metal%20glasses%2C%20dark%20utility%20jacket%2C%20direct%20confident%20stare%2C%20warm%20amber%20accent%20lighting%20against%20a%20deep%20charcoal%20backdrop%2C%20crisp%20shadows%2C%20film%20grain%2C%20modern%20editorial%20portrait%20composition&width=800&height=1000&seq=cast-portrait-04&orientation=portrait',
    date: '2025-01-08',
    dateLabel: '主演阵容',
    weight: 82,
    tags: ['配角', '温以宁', '局外人', '纪录']
    ,
    meta: [
      { label: '饰演角色', value: '温以宁（纪录片制片人）' },
      { label: '出场集数', value: '第 1、3、9、11 集' },
      { label: '代表作品', value: '《第二现场》《雾中风景》《我的朋友他的妻子》' },
      { label: '表演风格', value: '利落、节奏感强' },
    ],
    quote: '总得有一个人，替观众把话问出来。',
    body: [
      '温以宁是剧本里最早定下来的配角。编剧说，如果没有她，三个人的沉默会把观众挡在门外。',
      '她的台词几乎都是问句。你为什么回来、你到底想要什么、如果他不原谅你呢——这些问题像针，一句一句扎在主角身上。',
      '沈言在片场喜欢即兴加一句"然后呢"。导演最后保留了三处，其中一处在第九集，问得陈默整整沉默了十二秒。',
      '她说，演这个角色最难的地方是分寸：不能像一个审判者，只能像一个也很困惑的朋友。',
    ],
  },
  {
    id: 'cast-5',
    type: 'cast',
    title: '何秋棠',
    subtitle: '饰 陈母｜一句话压住整场戏',
    excerpt:
      '何秋棠在剧中只有六场戏，却贡献了全剧最锋利的一句台词："你要是真放下了，就不会记得她怕黑。"',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20dignified%20older%20Chinese%20woman%20in%20her%20sixties%20with%20silver%20grey%20hair%20pulled%20back%2C%20soft%20beige%20cardigan%2C%20knowing%20gentle%20expression%2C%20warm%20low%20amber%20lighting%20from%20a%20window%2C%20deep%20brown%20shadowed%20interior%20background%2C%20fine%20skin%20texture%2C%20film%20grain%2C%20warm%20intimate%20portrait%20photography&width=800&height=1000&seq=cast-portrait-05&orientation=portrait',
    date: '2025-01-08',
    dateLabel: '主演阵容',
    weight: 78,
    tags: ['长辈', '陈母', '家庭', '台词'],
    meta: [
      { label: '饰演角色', value: '陈母（退休教师）' },
      { label: '出场集数', value: '第 2、5、8、10、11、12 集' },
      { label: '代表作品', value: '《岁月长歌》《母亲的菜谱》《我的朋友他的妻子》' },
      { label: '表演风格', value: '生活化、细节取胜' },
    ],
    quote: '母亲不是来劝和的，她是来提醒他别再骗自己。',
    body: [
      '何秋棠的戏都在厨房和阳台完成。她说，这个角色的所有态度都藏在"递东西"的动作里——递一碗汤，递一件外套，递一句不太好听的真话。',
      '第十集那场母子对话，原本有三页纸。她建议只留四句，其余全部用剥豆子的动作填满。成片里那段长达四十秒的沉默，被观众称为"最疼的留白"。',
      '她给角色写了一份不拍出来的前史：陈母年轻时也等过一个人，等了四年，最后嫁给了别人。所以她从不劝儿子放下，只是提醒他别重复。',
      '剧组的人说，何秋棠到片场从不带剧本，台词全在脑子里。她说，这年纪了，背台词不如背人。',
    ],
  },
  {
    id: 'cast-6',
    type: 'cast',
    title: '江辰',
    subtitle: '饰 少年陈默｜所有回不去的部分',
    excerpt:
      '江辰在回忆段落中出演十九岁的陈默。他的镜头加起来不到二十分钟，却把"如果当年"这四个字演得让人难受。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20young%20Chinese%20man%20around%20twenty%20with%20messy%20black%20hair%20and%20a%20worn%20denim%20jacket%2C%20open%20hopeful%20expression%20with%20a%20hint%20of%20nervousness%2C%20warm%20sunset%20amber%20light%20on%20one%20side%20of%20the%20face%2C%20deep%20charcoal%20background%2C%20film%20grain%2C%20nostalgic%20cinematic%20portrait%20look&width=800&height=1000&seq=cast-portrait-06&orientation=portrait',
    date: '2025-01-08',
    dateLabel: '主演阵容',
    weight: 74,
    tags: ['青年', '少年陈默', '回忆线'],
    meta: [
      { label: '饰演角色', value: '少年陈默（回忆线）' },
      { label: '出场集数', value: '第 1、4、6、11 集回忆段落' },
      { label: '代表作品', value: '《夏日延长线》《毕业那天》《我的朋友他的妻子》' },
      { label: '表演风格', value: '自然、少年感' },
    ],
    quote: '他演的不是年轻，是还没学会藏。',
    body: [
      '江辰进组时刚满二十岁。为了和成年陈默衔接，他反复看林知远的片段，学他的走路节奏和说话前的停顿。',
      '回忆线用的是完全不同的影像语言：手持、颗粒更粗、色彩更暖。江辰的表演被要求"更亮一点"，因为那时候的陈默还没有学会沉默。',
      '第六集的毕业合影戏，他站在最右边。导演喊卡之后他问，我是不是那个被剪掉的人。导演说，你自己觉得呢。他没再问。',
      '他说自己最喜欢的一场戏是雨里骑车，因为"那时候他还相信只要骑得够快，就能把所有事情甩在后面"。',
    ],
  },
  {
    id: 'cast-7',
    type: 'cast',
    title: '白露',
    subtitle: '饰 林小满｜站在局外，替所有人递纸巾',
    excerpt:
      '白露饰演江暖的店员林小满。她话多、爱笑、总在打岔，是全剧唯一稳定的暖色。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20cheerful%20young%20Chinese%20woman%20in%20her%20late%20twenties%20with%20a%20loose%20ponytail%20and%20a%20mustard%20yellow%20knit%20vest%20over%20a%20white%20shirt%2C%20warm%20playful%20smile%2C%20soft%20amber%20window%20light%2C%20deep%20warm%20shadowed%20interior%20background%2C%20film%20grain%2C%20friendly%20cinematic%20portrait&width=800&height=1000&seq=cast-portrait-07&orientation=portrait',
    date: '2025-01-08',
    dateLabel: '主演阵容',
    weight: 70,
    tags: ['配角', '林小满', '暖色', '日常'],
    meta: [
      { label: '饰演角色', value: '林小满（酒吧店员）' },
      { label: '出场集数', value: '第 1—12 集（除第 8 集）' },
      { label: '代表作品', value: '《小城小事》《周末不加班》《我的朋友他的妻子》' },
      { label: '表演风格', value: '生活流、即兴感强' },
    ],
    quote: '如果全剧都在克制，总得有人负责把气氛拉回来。',
    body: [
      '林小满这个角色是后期加的。编剧在第三稿时发现，全剧太安静了，需要一个"会说话的人"来给观众喘气的机会。',
      '白露给角色加了很多小设定：说话时习惯转抹布、记不住客人的名字但记得住他们喝什么、手机壳上贴满了贴纸。',
      '她最出彩的一场戏是在第五集，江暖挂掉电话之后，小满什么也没问，只是把热牛奶推过去，说了一句：凉了就不好喝了。',
      '白露说，演这个角色她只有一个原则：不许同情。小满对江暖的感情是"我知道你不好受，但我还是想让你笑一下"，不是怜悯。',
    ],
  },
  {
    id: 'cast-8',
    type: 'cast',
    title: '罗敬',
    subtitle: '饰 老魏｜旧城的守夜人',
    excerpt:
      '罗敬饰演的酒吧房东老魏，出场总是带着钥匙串的声响。他知道这栋楼里发生过的所有事，但从不主动说。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20character%20portrait%20of%20a%20seasoned%20Chinese%20man%20in%20his%20late%20fifties%20with%20short%20grey%20hair%20and%20a%20weathered%20face%2C%20wearing%20a%20dark%20canvas%20work%20jacket%2C%20holding%20a%20bunch%20of%20keys%2C%20quiet%20observant%20expression%2C%20warm%20amber%20practical%20light%2C%20deep%20charcoal%20shadow%20background%2C%20film%20grain%2C%20gritty%20cinematic%20portrait&width=800&height=1000&seq=cast-portrait-08&orientation=portrait',
    date: '2025-01-08',
    dateLabel: '主演阵容',
    weight: 66,
    tags: ['配角', '老魏', '旧城', '见证者'],
    meta: [
      { label: '饰演角色', value: '老魏（旧城房东）' },
      { label: '出场集数', value: '第 1、6、9、12 集' },
      { label: '代表作品', value: '《老工厂》《北岸》《我的朋友他的妻子》' },
      { label: '表演风格', value: '不动声色、生活质感' },
    ],
    quote: '他什么都知道，只是这栋楼里的人都太会藏了。',
    body: [
      '老魏的钥匙串是罗敬自己带来的道具，从自己家抽屉里翻出来的。他说，一串钥匙能演一个人的半辈子。',
      '这个角色原本只有一句台词，罗敬和导演商量后加了三场戏，全部是"不说话"的：修门锁、扫台阶、把招牌灯重新接上。',
      '第六集，是他把那个装满旧书的箱子搬进片场。观众后来回看才发现，整条线索是从他手里递出去的。',
      '罗敬说，老魏不是旁观者，他是这栋楼的记忆。人走了，房子还记得。',
    ],
  },
];